import "../components/swalStyle/customStyle.css";
import { getInstance } from "./baseapi";
import Swal from "sweetalert2";

const instance = getInstance();

export const createAndUpdateCust = async (body) => {
    try {
        const formData = new FormData()
        formData.append('cscare_description_en', body.cscare_description_en)
        formData.append('cscare_description_th', body.cscare_description_th)
        formData.append('helpdesk_description_en', body.helpdesk_description_en)
        formData.append('helpdesk_description_th', body.helpdesk_description_th)
        formData.append('building_rec_description_en', body.building_rec_description_en)
        formData.append('building_rec_description_th', body.building_rec_description_th)
        formData.append('mailroom_description_en', body.mailroom_description_en)
        formData.append('mailroom_description_th', body.mailroom_description_th)
        if (body.helpdesk_description_images.length > 0) {
            body.helpdesk_description_images.forEach((helpdesk_description_images, index) => {
                if (helpdesk_description_images.file?.file) {
                    const blob = new Blob([helpdesk_description_images.file.file], { type: helpdesk_description_images.file.file.type });
                    const parts = helpdesk_description_images.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: helpdesk_description_images.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: helpdesk_description_images.file.size
                    });
        
                    formData.append(`helpdesk_description_images`, file);
                } else {
                    formData.append(`helpdesk_description_images`, helpdesk_description_images.file);
                }
            });
        }
        else{
            formData.append('helpdesk_description_images', null)
        }
        if (body.building_rec_images.length > 0) {
            body.building_rec_images.forEach((building_rec_images, index) => {
                if (building_rec_images.file?.file) {
                    const blob = new Blob([building_rec_images.file.file], { type: building_rec_images.file.file.type });
                    const parts = building_rec_images.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: building_rec_images.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: building_rec_images.file.size
                    });
        
                    formData.append(`building_rec_images`, file);
                } else {
                    formData.append(`building_rec_images`, building_rec_images.file);
                }
            });
        }
        else{
            formData.append('building_rec_images', null)
        }
        if (body.mailroom_description_image.length > 0) {
            body.mailroom_description_image.forEach((mailroom_description_image, index) => {
                if (mailroom_description_image.file?.file) {
                    const blob = new Blob([mailroom_description_image.file.file], { type: mailroom_description_image.file.file.type });
                    const parts = mailroom_description_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: mailroom_description_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: mailroom_description_image.file.size
                    });
        
                    formData.append(`mailroom_description_image`, file);
                } else {
                    formData.append(`mailroom_description_image`, mailroom_description_image.file);
                }
            });
        }
        else{
            formData.append('mailroom_description_image', null)
        }

        const rs = await instance.post(`/api/mgr/ourservice/customer-care`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });

        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }

        // return true
    } catch (error) {
        throw error;
    }
};

export const getDataCust = async (body) => {
    try {

        const rs = await instance.get(`/api/mgr/ourservice/customer-care`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};

export const createAndUpdateClub = async (body) => {
    try {
        const formData = new FormData()
        formData.append('club_description_en', body.club_description_en)
        formData.append('club_description_th', body.club_description_th)
        formData.append('diamond_description_en', body.diamond_description_en)
        formData.append('diamond_description_th', body.diamond_description_th)
        if (body.diamond_image.length > 0) {
            body.diamond_image.forEach((diamond_image, index) => {
                if (diamond_image.file?.file) {
                    const blob = new Blob([diamond_image.file.file], { type: diamond_image.file.file.type });
                    const parts = diamond_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: diamond_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: diamond_image.file.size
                    });
        
                    formData.append(`diamond_image`, file);
                } else {
                    formData.append(`diamond_image`, diamond_image.file);
                }
            });
        }
        else{
            formData.append('diamond_image', null)
        }

        const rs = await instance.post(`/api/mgr/ourservice/club-loung`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });

        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }

        // return true
    } catch (error) {
        throw error;
    }
};

export const getDataClub = async (body) => {
    try {

        const rs = await instance.get(`/api/mgr/ourservice/club-loung`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};

export const createAndUpdateShuttleBus = async (body) => {
    try {
        const formData = new FormData()
        formData.append('shuttle_description_en', body.shuttle_description_en)
        formData.append('shuttle_description_th', body.shuttle_description_th)
        formData.append('shuttle_routing_en', body.shuttle_routing_en)
        formData.append('shuttle_routing_th', body.shuttle_routing_th)
        if (body.image.length > 0) {
            body.image.forEach((image, index) => {
                if (image.file?.file) {
                    const blob = new Blob([image.file.file], { type: image.file.file.type });
                    const parts = image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: image.file.size
                    });
        
                    formData.append(`image`, file);
                } else {
                    formData.append(`image`, image.file);
                }
            });
        }
        else{
            formData.append('image', null)
        }
        
        if (body.shuttle_map_img.length > 0) {
            body.shuttle_map_img.forEach((shuttle_map_img, index) => {
                if (shuttle_map_img.file?.file) {
                    const blob = new Blob([shuttle_map_img.file.file], { type: shuttle_map_img.file.file.type });
                    const parts = shuttle_map_img.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: shuttle_map_img.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: shuttle_map_img.file.size
                    });
        
                    formData.append(`shuttle_map_img`, file);
                } else {
                    formData.append(`shuttle_map_img`, shuttle_map_img.file);
                }
            });
        }
        else{
            formData.append('shuttle_map_img', null)
        }

        const rs = await instance.post(`/api/mgr/ourservice/shuttlebus`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });

        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }

        // return true
    } catch (error) {
        throw error;
    }
};

export const getDataShuttleBus = async (body) => {
    try {

        const rs = await instance.get(`/api/mgr/ourservice/shuttlebus`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};

export const createAndUpdateCarpark = async (body) => {
    try {
        const formData = new FormData()
        formData.append('carpark_description_en', body.carpark_description_en)
        formData.append('carpark_description_th', body.carpark_description_th)
        formData.append('lpr_description_en', body.lpr_description_en)
        formData.append('lpr_description_th', body.lpr_description_th)
        formData.append('lady_parking_description_en', body.lady_parking_description_en)
        formData.append('lady_parking_description_th', body.lady_parking_description_th)
        formData.append('callpoint_description_en', body.callpoint_description_en)
        formData.append('callpoint_description_th', body.callpoint_description_th)
        formData.append('shuttle_description_en', body.shuttle_description_en)
        formData.append('shuttle_description_th', body.shuttle_description_th)
        formData.append('driver_description_en', body.driver_description_en)
        formData.append('driver_description_th', body.driver_description_th)
        formData.append('facial_recog_description_en', body.facial_recog_description_en)
        formData.append('facial_recog_description_th', body.facial_recog_description_th)
        if (body.lpr_image.length > 0) {
            body.lpr_image.forEach((lpr_image, index) => {
                if (lpr_image.file?.file) {
                    const blob = new Blob([lpr_image.file.file], { type: lpr_image.file.file.type });
                    const parts = lpr_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: lpr_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: lpr_image.file.size
                    });
        
                    formData.append(`lpr_image`, file);
                } else {
                    formData.append(`lpr_image`, lpr_image.file);
                }
            });
        }
        else{
            formData.append('lpr_image', null)
        }
        if (body.lady_parking_image.length > 0) {
            body.lady_parking_image.forEach((lady_parking_image, index) => {
                if (lady_parking_image.file?.file) {
                    const blob = new Blob([lady_parking_image.file.file], { type: lady_parking_image.file.file.type });
                    const parts = lady_parking_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: lady_parking_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: lady_parking_image.file.size
                    });
        
                    formData.append(`lady_parking_image`, file);
                } else {
                    formData.append(`lady_parking_image`, lady_parking_image.file);
                }
            });
        }
        else{
            formData.append('lady_parking_image', null)
        }
        if (body.callpoint_description_image.length > 0) {
            body.callpoint_description_image.forEach((callpoint_description_image, index) => {
                if (callpoint_description_image.file?.file) {
                    const blob = new Blob([callpoint_description_image.file.file], { type: callpoint_description_image.file.file.type });
                    const parts = callpoint_description_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: callpoint_description_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: callpoint_description_image.file.size
                    });
        
                    formData.append(`callpoint_description_image`, file);
                } else {
                    formData.append(`callpoint_description_image`, callpoint_description_image.file);
                }
            });
        }
        else{
            formData.append('callpoint_description_image', null)
        }
        if (body.shuttle_image.length > 0) {
            body.shuttle_image.forEach((shuttle_image, index) => {
                if (shuttle_image.file?.file) {
                    const blob = new Blob([shuttle_image.file.file], { type: shuttle_image.file.file.type });
                    const parts = shuttle_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: shuttle_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: shuttle_image.file.size
                    });
        
                    formData.append(`shuttle_image`, file);
                } else {
                    formData.append(`shuttle_image`, shuttle_image.file);
                }
            });
        }
        else{
            formData.append('shuttle_image', null)
        }
        if (body.driver_image.length > 0) {
            body.driver_image.forEach((driver_image, index) => {
                if (driver_image.file?.file) {
                    const blob = new Blob([driver_image.file.file], { type: driver_image.file.file.type });
                    const parts = driver_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: driver_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: driver_image.file.size
                    });
        
                    formData.append(`driver_image`, file);
                } else {
                    formData.append(`driver_image`, driver_image.file);
                }
            });
        }
        else{
            formData.append('driver_image', null)
        }
        if (body.facial_recog_image.length > 0) {
            body.facial_recog_image.forEach((facial_recog_image, index) => {
                if (facial_recog_image.file?.file) {
                    const blob = new Blob([facial_recog_image.file.file], { type: facial_recog_image.file.file.type });
                    const parts = facial_recog_image.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: facial_recog_image.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: facial_recog_image.file.size
                    });
        
                    formData.append(`facial_recog_image`, file);
                } else {
                    formData.append(`facial_recog_image`, facial_recog_image.file);
                }
            });
        }
        else{
            formData.append('facial_recog_image', null)
        }

        const rs = await instance.post(`/api/mgr/ourservice/carpark-security`, formData, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });

        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }

        // return true
    } catch (error) {
        throw error;
    }
};

export const getDataCarpark = async (body) => {
    try {

        const rs = await instance.get(`/api/mgr/ourservice/carpark-security`, {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("tokenBackoffice"),
            },
        });
        if (rs.data.status.toLowerCase() == "success") {
            return rs.data;
        } else {
            throw new Error(`error durring fetch api`);
        }
        // return true
    } catch (error) {
        throw error;
    }
};